<template>
  <v-dialog v-model="dialog" max-width="640" persistent scrollable>
    <v-card>
      <v-toolbar tile card flat dense color="transparent">
        <h3>
          <v-icon small class="black--text">mdi-plus</v-icon>
          {{ formTitle }}
        </h3>
      </v-toolbar>

      <v-card-text class="pa-2">
        <v-container grid-list-md class="pt-0">
          <!-- Product -->
          <span class="font-weight-bold caption">
            <v-icon size="14" class="pr-1 pt-1">mdi-cart-variant</v-icon>
            Product
          </span>
          <v-layout row wrap class="px-0 pb-4">
            <!-- Product category -->
            <v-flex xs12 sm12 md6>
              <v-autocomplete
                :items="contract.supplier_product_categories"
                label="Product Category"
                v-model="productTrade.product_category_id"
                item-value="id"
                item-text="name"
                v-bind="commonProps"
                placeholder="Select a product category"
              />
            </v-flex>
            <!-- Product id -->
            <v-slide-x-transition>
              <v-flex xs12 sm12 md6 v-show="productTrade.product_category_id">
                <v-autocomplete
                  :items="filteredProducts()"
                  label="Product"
                  v-model="productTrade.product_id"
                  item-value="id"
                  item-text="name"
                  v-bind="commonProps"
                  placeholder="Product to trade"
                />
              </v-flex>
            </v-slide-x-transition>
          </v-layout>

          <v-slide-y-transition>
            <div v-show="productTrade.product_id">
              <!-- Packaging -->
              <span class="font-weight-bold caption mt-4">
                <v-icon size="14" class="pr-1 pt-1">mdi-package-variant</v-icon>
                Packaging
              </span>

              <v-layout row wrap class="px-0 pb-4">
                <!-- Packaging -->
                <v-flex xs12 sm12 md6>
                  <v-autocomplete
                    :items="filteredPackagings()"
                    label="Packaging"
                    v-model="productTrade.packaging_id"
                    item-value="id"
                    item-text="name"
                    v-bind="commonProps"
                    placeholder="Select a packaging"
                  />
                </v-flex>
                <!-- Packaging Info-->
                <v-slide-x-transition>
                  <v-flex xs12 sm12 md6 v-show="productTrade.packaging_id">
                    <v-autocomplete
                      :items="filteredPackagingInfos()"
                      label="Packaging Info"
                      v-model="productTrade.packaging_info_id"
                      item-value="id"
                      item-text="name"
                      v-bind="commonProps"
                      placeholder="Additionnal packaging details"
                  /></v-flex>
                </v-slide-x-transition>
              </v-layout>

              <v-slide-y-transition>
                <div
                  class="delayedTransition"
                  v-show="productTrade.packaging_id"
                >
                  <!-- Quantity -->
                  <span class="font-weight-bold caption mt-4">
                    <v-icon size="14" class="pr-1 pt-1"
                      >mdi-scale-balance</v-icon
                    >
                    Quantity
                  </span>
                  <v-layout row wrap class="px-0 pb-4">
                    <!-- Net weight -->
                    <v-flex xs12>
                      <v-text-field
                        type="number"
                        label="Net weight"
                        v-model.number="productTrade.net_weight"
                        v-bind="commonProps"
                        placeholder="0"
                        suffix="mt"
                      />
                    </v-flex>
                  </v-layout>
                </div>
              </v-slide-y-transition>
              <v-slide-y-transition>
                <div
                  class="delayedTransition2"
                  v-show="productTrade.packaging_id"
                >
                  <!-- Prices -->
                  <span class="font-weight-bold caption mt-4">
                    <v-icon size="14" class="pr-1 pt-1"
                      >mdi-cash-multiple</v-icon
                    >
                    Prices
                  </span>
                  <v-layout
                    row
                    wrap
                    class="px-0 pb-0 align-center justify-center"
                  >
                    <!-- Buying price -->
                    <v-flex xs12 sm12 md5 grow>
                      <v-text-field
                        type="number"
                        label="Buying price per mt"
                        v-model.number="productTrade.buying_tonne_price"
                        v-bind="commonProps"
                        placeholder="0"
                        :suffix="contract.supplier_currency.code + '/MT'"
                    /></v-flex>
                    <v-flex xs2 shrink class="text-xs-center">
                      <v-icon color="primary" class="pt-2"
                        >mdi-arrow-right-bold</v-icon
                      >
                    </v-flex>
                    <!-- Selling price-->
                    <v-flex xs12 sm12 md5 grow>
                      <v-text-field
                        type="number"
                        label="Selling price per mt"
                        v-model.number="productTrade.selling_tonne_price"
                        v-bind="commonProps"
                        placeholder="0"
                        :suffix="contract.customer_currency.code + '/MT'"
                    /></v-flex>
                  </v-layout>
                </div>
              </v-slide-y-transition>
            </div>
          </v-slide-y-transition>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="black" flat @click="resetForm()">
          <v-icon small class="pr-2">mdi-autorenew</v-icon>
          Clear form
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn color="error" flat @click="$emit('close')">
          <v-icon small class="pr-2">mdi-close</v-icon>
          Cancel
        </v-btn>

        <v-btn :disabled="!canSave" color="success" depressed @click="save">
          <v-icon small class="pr-2">mdi-content-save</v-icon>
          {{ editMode ? "Update" : "Save" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapGetters } from "vuex";
import CREATE_PRODUCT_TRADE from "../../graphql/product_trades/create.gql";
import UPDATE_PRODUCT_TRADE from "../../graphql/product_trades/update.gql";

export default {
  name: "ProductTradesForm",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    productTradeToEdit: {
      type: Object,
      required: false,
    },
    previsional: {
      type: Boolean,
      required: true,
    },
    contractId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      commonProps: {
        autocomplete: "nothingplease",
        "background-color": "white",
        "hide-details": true,
        dense: true,
      },
      editMode: false,
      productTrade: {
        product_category_id: "",
        product_id: "",
        packaging_id: "",
        packaging_info_id: "",
        net_weight: null,
        buying_tonne_price: null,
        selling_tonne_price: null,
        previsional: this.previsional,
        contract_id: this.contractId,
      },
    };
  },
  computed: {
    ...mapGetters("commonStore", [
      "product_categories",
      "categoryProducts",
      "packagings",
      "packaging_infos",
    ]),
    ...mapGetters("contractStore", ["contract"]),
    formTitle() {
      return this.editMode ? "Update traded product" : "Add traded product";
    },
    canSave() {
      if (
        !this.productTrade.product_id ||
        !this.productTrade.packaging_id ||
        !this.productTrade.net_weight ||
        !this.productTrade.buying_tonne_price ||
        !this.productTrade.selling_tonne_price
      )
        return false;

      return true;
    },
  },
  methods: {
    resetForm() {
      this.editMode = false;
      this.productTrade.product_id = "";
      this.productTrade.product_category_id = "";
      this.productTrade.packaging_id = "";
      this.productTrade.packaging_info_id = "";
      this.productTrade.net_weight = null;
      this.productTrade.buying_tonne_price = null;
      this.productTrade.selling_tonne_price = null;
      this.productTrade.previsional = this.previsional;
      this.productTrade.contract_id = this.contractId;
    },
    filteredPackagings() {
      let ret = this.contract.supplier_products.find(
        (e) => e.id === this.productTrade.product_id
      );
      return ret ? ret.packagings : [];
    },
    filteredPackagingInfos() {
      let ret = this.contract.supplier_products.find(
        (e) => e.id === this.productTrade.product_id
      );
      return ret ? ret.packaging_infos : [];
    },
    filteredProducts() {
      let currentProductId = this.productTrade.product_id;
      let currentCategoryId = this.productTrade.product_category_id;
      return this.getFilteredProducts(currentCategoryId, currentProductId);
    },
    getFilteredProducts(categoryId, productId) {
      const productIds = this.contract.supplier_products.map((e) => e.id);
      return this.categoryProducts(categoryId).filter((e) =>
        productIds.includes(e.id)
      );
    },
    save() {
      console.log(this.productTrade)
      if (this.editMode) {
        this.sendMutation(
          "updated",
          "product to trade",
          UPDATE_PRODUCT_TRADE,
          this.productTrade
        ).then((data) => {
          this.$emit("updatedProductTrade", data.update_product_trade)
          this.$emit("close");
          this.resetForm();
        }).catch((e) => {
          console.log(e);
          this.$emit("close");
        });
      }
      else {
        this.sendMutation(
          "created",
          "product to trade",
          CREATE_PRODUCT_TRADE,
          this.productTrade
        )
          .then((data) => {
            console.log("New product trade added:", data);
            this.$emit("newProduct", data.create_product_trade);
            this.$emit("close");
            this.resetForm();
          })
          .catch((e) => {
            console.log(e);
            this.$emit("close");
          });
      }
    },
  },
  watch: {
    productTradeToEdit() {
      if (this.productTradeToEdit) {
        this.editMode = true;
        console.log("Product trade to edit:", this.productTradeToEdit);
        this.productTrade.id = this.productTradeToEdit.id;
        this.productTrade.product_id = this.productTradeToEdit.product_id;
        this.productTrade.product_category_id =
          this.productTradeToEdit.product.product_category_id;
        this.productTrade.packaging_id = this.productTradeToEdit.packaging_id;
        this.productTrade.packaging_info_id =
          this.productTradeToEdit.packaging_info_id;
        this.productTrade.net_weight = this.productTradeToEdit.net_weight;
        this.productTrade.buying_tonne_price =
          this.productTradeToEdit.buying_tonne_price;
        this.productTrade.selling_tonne_price =
          this.productTradeToEdit.selling_tonne_price;
        this.productTrade.previsional = this.previsional;
        this.productTrade.contract_id = this.contractId;
      } else this.resetForm();
    },
  },
};
</script>
<style>
.delayedTransition {
  transition-delay: 400ms !important;
}
.delayedTransition2 {
  transition-delay: 800ms !important;
}
</style>
